<mat-form-field appearance="outline" [ngClass]="{ failed: !!UOMValidation() || !validSnapshot || !!warning }">
  @if (!isMaskedValue) {
    <input
      matInput
      [autocomplete]="autocompleteValue"
      [required]="required()"
      [placeholder]="placeholder() | translate"
      [formControl]="fc"
      (keydown.enter)="onChange(customValue())"
      (blur)="blurChange()"
      [maxlength]="maxlength"
      [avoidCopyPaste]
      [avoidActions]="avoidCopyandPasteActions"
      />
      @if (clearButtonEnabled()) {
        <mat-icon class="clear-button" (click)="clearValue()">close</mat-icon>
      }
    } @else {
      <input
        matInput
        autocomplete="new-password"
        type="password"
        [placeholder]="placeholder() | translate"
        disabled
        [value]="currentValue"
        [avoidCopyPaste]
        [avoidAllActions]="true"
        />
      }

      <!-- DISPLAYED IF MASKED DATA -->
    </mat-form-field>
